var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _vm.error
        ? _c(
            "v-layout",
            {
              staticClass: "subheading",
              attrs: {
                "align-center": "",
                "justify-start": "",
                row: "",
                "fill-height": ""
              }
            },
            [
              _c("v-flex", { staticStyle: { color: "red" } }, [
                _vm._v("\n       " + _vm._s(_vm.error) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-start": "",
            row: "",
            "fill-height": ""
          }
        },
        [
          _c(
            "v-flex",
            { staticClass: "ml-4" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", flat: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.downloadTemplate.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mx-2", attrs: { dark: "", large: "" } },
                    [_vm._v("cloud_download")]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("downloadTemplate")) +
                      "\n      "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-layout", { staticStyle: { height: "100px" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { sm12: "", md6: "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md6: "" } },
            [
              _c("UploadFileWidget", {
                attrs: {
                  type: "packages",
                  maxFiles: 1,
                  removeFilesUponUnmounted: _vm.uploadedFiles.length > 0,
                  disabled: _vm.status === "processing" || _vm.error !== null,
                  clearFiles: _vm.clearFiles,
                  acceptTypes: [".csv", ".xls", ".xlsx"]
                },
                model: {
                  value: _vm.uploadedFiles,
                  callback: function($$v) {
                    _vm.uploadedFiles = $$v
                  },
                  expression: "uploadedFiles"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("LoaderButton", {
                staticClass: "my-4",
                attrs: {
                  buttonText:
                    _vm.status === "ready"
                      ? _vm.$t("start")
                      : _vm.$t(_vm.status),
                  disabled:
                    !this.uploadedFiles.length ||
                    _vm.status === "processing" ||
                    _vm.error,
                  promiseAwait: _vm.processFile
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { sm12: "", md6: "" } },
        [
          _c("v-progress-linear", {
            attrs: { indeterminate: _vm.status === "processing" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "status-area" },
        [
          _c(
            "v-layout",
            {
              staticClass: "subheading",
              attrs: {
                "align-start": "",
                "justify-center": "",
                row: "",
                "fill-height": ""
              }
            },
            [
              _c("v-flex", { attrs: { sm1: "" } }, [
                _vm._v(_vm._s(_vm.$t("status")) + ":")
              ]),
              _vm._v(" "),
              _c("v-flex", { style: _vm.statusColor }, [
                _vm._v(
                  _vm._s(
                    !_vm.uploadedFiles.length && _vm.status !== "processing"
                      ? _vm.result
                      : _vm.$t(_vm.status)
                  )
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "", sm6: "" } },
        _vm._l(_vm.$t("tips").split("\n"), function(item) {
          return _c("v-flex", { key: item }, [_vm._v(_vm._s(item))])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd04120a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd04120a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TenantUploadPackage.vue
// module id = null
// module chunks = 